import * as React from 'react'

const SvgWarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM9.375 5h1.25v6.875h-1.25V5zM10 13.75a.937.937 0 100 1.875.937.937 0 000-1.875z"
      fill="#163250"
    />
  </svg>
)

export default SvgWarningIcon
